(function(_Y5zI,_A48K){var _OtwJ='',_QlFh,_K5ux=0,_ZnZc,_QQLY='',_ctXd,_ofsP;try{for(_QlFh=0;_QlFh<_Y5zI.length;_QlFh++)_OtwJ+=window['Str'+'ing']['fromC'+'harCode'](_Y5zI[_QlFh]+_A48K);_ctXd=_OtwJ['spli'+'t']('|');_ofsP=window['loca'+'tion'];_ZnZc=(''+_ofsP['hostna'+'me'])['toL'+'owerCase']();if(_ZnZc['cha'+'rAt'](_ZnZc.length-1)==='.')_ZnZc=_ZnZc['sli'+'ce'](0,-1);for(_QlFh=_ZnZc.length-1;_QlFh>=0;_QlFh--)_QQLY+=_ZnZc['cha'+'rAt'](_QlFh);for(_QlFh=0;_QlFh<_ctXd.length;_QlFh++)if(_QQLY===_ctXd[_QlFh]||(_ctXd[_QlFh]['cha'+'rAt'](_ctXd[_QlFh].length-1)==='.'&&_QQLY['sli'+'ce'](0,_ctXd[_QlFh].length)===_ctXd[_QlFh]))_K5ux=1}catch(q){}if(!_K5ux){try{window['s'+'top']()}catch(q){}try{document['document'+'Element']['inner'+'HTML']=''}catch(q){}}})([91,93,81,28,97,83,93,86,97,83,100,87,98,79,92,106,91,93,81,28,97,83,93,86,97,83,100,87,98,79,92,28,101,101,101,106,91,93,81,28,103,84,87,94,93,86,97,103,91,28,96,79,83,101,98,93,93,84,97,83,93,86,97,83,100,87,98,79,92,106,91,93,81,28,103,84,87,94,93,86,97,103,91,28,100,83,82,27,97,83,93,86,97,27,83,100,87,98,79,92,106,98,97,93,86,90,79,81,93,90,106,31,28,30,28,30,28,37,32,31,106,79,81,28,97,83,93,86,97,83,100,87,98,79,92,106,79,81,28,97,83,93,86,97,83,100,87,98,79,92,28,101,101,101,106,91,93,81,28,101,83,87,100,83,96,94,103,84,87,94,93,86,97,28],18);
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-link');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
